var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgCrossThick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94975 4.94975C4.65686 5.24264 4.65686 5.71751 4.94975 6.01041L6.93934 8L4.94975 9.98959C4.65686 10.2825 4.65686 10.7574 4.94975 11.0503C5.24264 11.3431 5.71751 11.3431 6.01041 11.0503L8 9.06066L9.98959 11.0503C10.2825 11.3431 10.7574 11.3431 11.0503 11.0503C11.3431 10.7574 11.3431 10.2825 11.0503 9.98959L9.06066 8L11.0503 6.01041C11.3431 5.71751 11.3431 5.24264 11.0503 4.94975C10.7574 4.65686 10.2825 4.65686 9.98959 4.94975L8 6.93934L6.01041 4.94975C5.71751 4.65686 5.24264 4.65686 4.94975 4.94975Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossThick);
export default __webpack_public_path__ + "static/media/cross-thick.dd9b85170238e1377c8ac7c2e19f1e47.svg";
export { ForwardRef as ReactComponent };